<p-tabView>
  <p-tabPanel header="Target Accounts">
    <span class="p-input-icon-left search-filter">
  <i class="pi pi-search"></i>
  <input
    pInputText
    [(ngModel)]="searchValueTargetAccounts"
    class="target-account-search-bar"
    (input)="dtTarget.filterGlobal($event.target.value, 'contains')"
    placeholder="Search Target Accounts..."/>
  </span>
    <p-table #dtTarget [value]="previewTableDataForTargetAccounts" [globalFilterFields]="['targetAccount']" [scrollable]="true" scrollHeight="300px" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Target Accounts</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>{{ row.targetAccount || '' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
  <p-tabPanel header="Offer Sets">
    <span class="p-input-icon-left search-filter">
  <i class="pi pi-search"></i>
  <input
    pInputText
    [(ngModel)]="searchValueOfferSets"
    (input)="dtOfferSet.filterGlobal($event.target.value, 'contains')"
    placeholder="Search Offer Sets..."/>
  </span>
    <p-table #dtOfferSet [value]="previewTableDataForOfferSets" [globalFilterFields]="['offerSet']" [scrollable]="true" scrollHeight="300px" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr>
          <th>Offer Sets</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-i="rowIndex">
        <tr>
          <td>{{ row.offerSet || '' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
</p-tabView>
<div *ngIf="isSave" class="confirm-preview-text">
  <p-divider></p-divider>
  <label>This rule will share <b>{{ this.appliedFilters['offerSetNames'].length }}</b> Offer Sets to
    <b>{{ this.appliedFilters['targetAccountNames'].length }}</b> account(s). Do you want to save and apply this
    rule?</label>
</div>
<div *ngIf="isSave" class="confirm-preview-button">
  <button pButton type="button" label="Leave Preview" class="leave-preview-button" (click)="this.dialogRef.close('cancel')"></button>
  <button pButton type="button" label="Confirm" class="p-button-success" (click)="this.dialogRef.close('save')"></button>
</div>
